export const defaultPlayListName = 'Play list';
export const noNamePlayListName = 'No name playlist';
